import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  TemplateRef,
  ViewChild,
  inject,
  input,
  model,
  output,
} from '@angular/core';
import { Modal } from '@spirit-testing/component-library';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

/**
 * Bestätigt vor dem Speichern eines mehrfach verwendeten Testmoduls (NEX-688): die
 * Änderung wirkt sich auf alle Verwender aus. Erscheint zwischen dem Klick auf
 * Speichern und dem tatsächlichen Persist, sobald {@code usageCount > 1}. A11y
 * (aria-modal, ESC, focus-trap) liefert die Component-Library {@code lib-modal}.
 */
@Component({
  selector: 'app-multi-use-confirm-dialog',
  imports: [Modal, TranslatePipe, MatIcon],
  templateUrl: './multi-use-confirm-dialog.component.html',
  styleUrl: './multi-use-confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiUseConfirmDialogComponent implements AfterViewInit {
  private readonly cdr = inject(ChangeDetectorRef);

  readonly visible = model(false);
  /** Gesamtzahl der weiteren Verwender (Testfälle & Module). */
  readonly usageCount = input(0);
  readonly moduleTitle = input('');

  readonly confirmed = output<void>();

  @ViewChild('content') contentTemplate!: TemplateRef<unknown>;
  resolvedTemplate: TemplateRef<unknown> | null = null;

  ngAfterViewInit(): void {
    this.resolvedTemplate = this.contentTemplate;
    this.cdr.detectChanges();
  }

  onConfirm(): void {
    this.confirmed.emit();
    this.visible.set(false);
  }

  onCancel(): void {
    this.visible.set(false);
  }
}
